module.exports = __webpack_public_path__ + "static/img/img3.fa686f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img3.png
// module id = X00j
// module chunks = 1